import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import { BrowserRouter } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faStroopwafel } from '@fortawesome/free-solid-svg-icons';
import * as serviceWorker from './serviceWorker';
import MessageBanking from './message-banking';
import filesStore from './messages/stores/files.store';
import fileDetailsStore from './messages/stores/fileDetails.store';
import commonStore from './common/stores/common.store';
import recorderStore from './messages/stores/recorder.store';
import authenticationStore from './messages/stores/authentication.store';
import 'bootstrap-css-only/css/bootstrap.min.css';
import './index.scss';

library.add(faStroopwafel);

const stores = {
  authenticationStore,
  commonStore,
  filesStore,
  fileDetailsStore,
  recorderStore,
};

ReactDOM.render(
  <Provider {...stores}>
    <BrowserRouter>
      <MessageBanking />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();



// WEBPACK FOOTER //
// ./src/index.js